<template>
  <img
    src="/images/icons/membership-icon-filled2.svg"
    loading="lazy"
    width="20"
    height="20"
    alt="user icon"
  />
</template>

<script setup></script>
